import { render, staticRenderFns } from "./ApproveTransferToNhanh.vue?vue&type=template&id=78ae81fe"
import script from "./ApproveTransferToNhanh.vue?vue&type=script&lang=js"
export * from "./ApproveTransferToNhanh.vue?vue&type=script&lang=js"
import style0 from "./ApproveTransferToNhanh.vue?vue&type=style&index=0&id=78ae81fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports